import initialState from './../initialState';

const reducers = {
  LOGIN_SUCCESS: (state, payload) => {
    let user = Object.assign({}, payload.login);
    const username = payload.login.username;
    const password = payload.login.password;
    let companyName = '';
    if(user.company){
      companyName = user.company.name;
    }
    return [...state, Object.assign({}, user, {password, username, companyName})];
  },
  USER_RETRIEVED_SUCCESS: (state, payload) => {
    return [...state, Object.assign({}, payload.user)];
  },
  USER_RETRIEVED_FAILURE: (state, payload) => {
    return Object.assign({}, state, payload.user);
  },
  UPDATE_USER_SUCCESS: (state, payload) => {
    let info = Object.assign({}, payload.newInfo);
    return [Object.assign(Object.assign({}, state[0]), info)];
  },
  LOGOUT_USER: () => {
    return [];
  }
};

export default function user(state = initialState.user, action) {
  let reducer = reducers[action.type];
  return (reducer ? reducer(state, action) : state);
}




/** WEBPACK FOOTER **
 ** ./src/reducers/account/userReducer.js
 **/